import script from "./MoreProgramsBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./MoreProgramsBlock.vue?vue&type=script&setup=true&lang=js"

import "./MoreProgramsBlock.vue?vue&type=style&index=0&id=18eff530&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18eff530"]])

export default __exports__